import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationContentBlockerPost = {
    path: "/template/content-blocker",
    method: ERouteHttpVerb.POST
};
export { routeLocationContentBlockerPost };
